export default "__VITE_ASSET__811a89ee__"